const RegistrationPage = () => import('./index.vue')
const OtpPage = () => import('./otp.vue')

export default [
    {
        path: '/register/:status',
        component: RegistrationPage,
        name: 'RegistrationIndex'
    },
    {
        path: '/verify/:account/:id',
        component: OtpPage,
        name: 'OtpIndex'
    }
]